// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qk-1";
export var spinner = "_qk-0";